import  { useEffect, useState } from 'react'
import { CommonHeader, EmptyListPage, ErrorSuccessModal, Loader } from '../../../../components/commons'
import DailyUserHeader from '../../../../components/AdminReports/UserLoginSessionReport/DailyUserHeader'
import {  handleDate } from '../../../../utils/commonFunctions'
import { RootState } from '../../../../redux/rootReducers'
import { getDailyActiveUserReportAction, resetDailyActiveUserList, resetListingError, resetListingSuccess } from '../../../../redux/listing'
import { connect } from "react-redux";
import { formatDate } from "../../../../utils/commonFunctions";
import DailyActiveUserCountTable from '../../../../components/AdminReports/UserLoginSessionReport/DailyActiveUserCountTable'
import { DAILY_ACTIVE_USER_COUNT_HEADERS } from '../../../../constant/tableHeadersConstants/userLoginSessionReportsHeaderConst'
import { resetSession } from '../../../../redux/auth'
import { GetDailyActiveUserCountPayloadType } from '../../../../commonTypes/listing'
import { DailyActiveUserCountType } from '../../../../redux/listing/listingTypes'

type AppProps={
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  dailyActiveUserList:[] | DailyActiveUserCountType[];
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchGetDailyActiveUserReportAction: (data: GetDailyActiveUserCountPayloadType) => void;
  dispatchResetDailyActiveUserList: () => void;
  dispatchResetSession: () => void;

}
const DailyActiveUser = ({
  token,
fetching,
error,
success,
statusCode,
dailyActiveUserList,
dispatchResetListingError,
dispatchResetListingSuccess,
dispatchGetDailyActiveUserReportAction,
dispatchResetDailyActiveUserList,
dispatchResetSession,

}:AppProps) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");

  useEffect(() => {
    dispatchResetListingError();
  dispatchResetListingSuccess();
  dispatchResetDailyActiveUserList()
}, []);

  useEffect(() => {
    if (displayEndDate !==endDate || startDate !== displayStartDate) {
      setDisplayStartDate(formatDate(startDate));
      setDisplayEndDate(formatDate(endDate));
    }

  }, [dailyActiveUserList])
  

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmitData = () => {
    
let finalData: GetDailyActiveUserCountPayloadType = {
      token,
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
    };

    dispatchGetDailyActiveUserReportAction(finalData);
  }
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingError();
            }}
          />
        );
      }
    }

    return false;
  };
 
  return (
    <>
    <div className="row">
        <div className="col-md-6">
          <CommonHeader
            title="Daily Active User"
          />
        </div>
      </div>
        <div className="col-md-12 mt-4">
        <div className="new-table-card">
            <DailyUserHeader
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              handleSubmitData={handleSubmitData}
            />
            <hr className="mt-4 mb-4" />
            {dailyActiveUserList && dailyActiveUserList?.length === 0 && !fetching ? (
              <EmptyListPage
                title="No Data Found!"
                imageWidth="30%"
              />
            ) : (
                <>
                <h5 className="text-center">Daily Active User Count</h5>
                <div className="d-flex justify-content-center mt-3">
                  <h6 className="text-center mr-4">
                    Start Date:{" "}
                    <span className="font-weight-bolder">
                      {displayStartDate}
                    </span>
                  </h6>
                  <h6 className="text-center">
                    End Date:{" "}
                    <span className="font-weight-bolder">{displayEndDate}</span>
                  </h6>
                </div>
                <DailyActiveUserCountTable
                  fetching={fetching}                
                  data={dailyActiveUserList}
                  tableHeaders={DAILY_ACTIVE_USER_COUNT_HEADERS}
                
                />
              </>
            )}
        </div>
      </div>
      {fetching && <Loader />}
        {handleErrorModal()}
            </>
  )
}


const mapStateToProps = (state: RootState) => ({
  success: state.listing.success,
  fetching: state.listing.fetching,
  token: state.auth.token,
  error: state.listing.error,
  statusCode: state.listing.statusCode,
  dailyActiveUserList:state.listing.dailyActiveUserList
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetListingSuccess: () => dispatch(resetListingSuccess()),
  dispatchResetListingError: () => dispatch(resetListingError()),  
  dispatchGetDailyActiveUserReportAction: (data: GetDailyActiveUserCountPayloadType) => dispatch(getDailyActiveUserReportAction(data)),
  dispatchResetDailyActiveUserList: () => dispatch(resetDailyActiveUserList()),
});


export default connect(mapStateToProps, mapDispatchToProps)(DailyActiveUser);
